// Meat sticky cart bar (phones). Floats above the bottom tab bar: item count
// + basket total on the left, "View cart" on the right.
import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Grid } from 'antd';
import { RightOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import { useActiveCart } from '@core/hooks/useCart';
import Price from '@components/base/Price';
import { useCopy } from '@/app/providers/useCopy';

const HIDDEN_ON = ['/cart', '/checkout', '/orders', '/account'];

export default function MobileCartBarMeat() {
  const t = useCopy();
  const screens = Grid.useBreakpoint();
  const hasResolvedBreakpoint = Object.keys(screens).length > 0;
  const isMobile = hasResolvedBreakpoint && !screens.md;
  const { cart, lineCount } = useActiveCart();
  const { pathname } = useLocation();
  const isVisible = isMobile && lineCount > 0 && !HIDDEN_ON.includes(pathname);

  useEffect(() => {
    document.documentElement.classList.toggle('meat-mobile-cart-bar-active', isVisible);
    return () => {
      document.documentElement.classList.remove('meat-mobile-cart-bar-active');
    };
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <div className="meat-mobile-cart-bar mx-cartbar">
      <span className="mx-cartbar__icon" aria-hidden>
        <ShoppingCartOutlined />
      </span>
      <div className="mx-cartbar__summary">
        <strong>
          {lineCount} {lineCount === 1 ? t('item', 'item') : t('items', 'items')}
        </strong>
        <Price amount={cart?.grandTotal ?? cart?.subtotal ?? 0} />
      </div>
      <Link to="/cart" className="mx-cartbar__cta">
        {t('viewCart', 'View cart')} <RightOutlined />
      </Link>
    </div>
  );
}
